document.addEventListener("DOMContentLoaded", () => {
  const openButton = document.getElementById("ace-submit-order");
  const modal = document.getElementById("ace-order-modal");
  const closeButton = document.getElementById("ace-order-close");
  const cancelButton = document.getElementById("ace-order-cancel");
  const doneButton = document.getElementById("ace-order-done");
  const form = document.getElementById("ace-order-form");
  const errorBox = document.getElementById("ace-order-error");

    const addressInput = document.getElementById("ace-address");
  const addressSuggestions = document.getElementById(
    "ace-address-suggestions"
  );

  let addressSearchTimer = null;
  let addressSearchController = null;
  let activeAddressIndex = -1;
  let currentAddressResults = [];

  function closeAddressSuggestions() {
    if (!addressSuggestions || !addressInput) return;

    addressSuggestions.hidden = true;
    addressSuggestions.innerHTML = "";
    addressInput.setAttribute("aria-expanded", "false");
    activeAddressIndex = -1;
    currentAddressResults = [];
  }

  function chooseAddress(address) {
    if (!addressInput) return;

    addressInput.value = address.full_address;
    closeAddressSuggestions();
    addressInput.focus();
  }

  function setActiveAddress(index) {
    if (!addressSuggestions) return;

    const options = Array.from(
      addressSuggestions.querySelectorAll("[role='option']")
    );

    if (options.length === 0) return;

    if (index < 0) {
      index = options.length - 1;
    }

    if (index >= options.length) {
      index = 0;
    }

    activeAddressIndex = index;

    options.forEach((option, optionIndex) => {
      option.classList.toggle(
        "ace-address-suggestion--active",
        optionIndex === activeAddressIndex
      );

      option.setAttribute(
        "aria-selected",
        optionIndex === activeAddressIndex ? "true" : "false"
      );
    });

    options[activeAddressIndex]?.scrollIntoView({
      block: "nearest",
    });
  }

  function renderAddressSuggestions(addresses) {
    if (!addressSuggestions || !addressInput) return;

    addressSuggestions.innerHTML = "";
    currentAddressResults = addresses;
    activeAddressIndex = -1;

    if (!addresses.length) {
      closeAddressSuggestions();
      return;
    }

    addresses.forEach((address, index) => {
      const option = document.createElement("button");

      option.type = "button";
      option.className = "ace-address-suggestion";
      option.setAttribute("role", "option");
      option.setAttribute("aria-selected", "false");
      option.textContent = address.full_address;

      option.addEventListener("mousedown", (event) => {
        event.preventDefault();
      });

      option.addEventListener("click", () => {
        chooseAddress(currentAddressResults[index]);
      });

      addressSuggestions.appendChild(option);
    });

    addressSuggestions.hidden = false;
    addressInput.setAttribute("aria-expanded", "true");
  }

  async function searchNzPostAddresses(query) {
    if (!addressInput || !addressSuggestions) return;

    if (addressSearchController) {
      addressSearchController.abort();
    }

    addressSearchController = new AbortController();

    try {
      const response = await fetch(
        `/apps/ace-order-gateway/nzpost-address?q=${encodeURIComponent(query)}`,
        {
          signal: addressSearchController.signal,
        }
      );

      if (!response.ok) {
        throw new Error(`NZ Post search returned HTTP ${response.status}`);
      }

      const result = await response.json();

      if (!result?.ok || !Array.isArray(result.addresses)) {
        throw new Error(
          result?.message || "NZ Post did not return address results."
        );
      }

      renderAddressSuggestions(result.addresses);
    } catch (error) {
      if (error?.name === "AbortError") {
        return;
      }

      console.warn("NZ Post address search unavailable:", error);

      // Manual address entry remains available if NZ Post is unavailable.
      closeAddressSuggestions();
    }
  }

  if (addressInput && addressSuggestions) {
    addressInput.addEventListener("input", () => {
      const query = addressInput.value.trim();

      clearTimeout(addressSearchTimer);
      closeAddressSuggestions();

      if (query.length < 4) {
        return;
      }

      addressSearchTimer = setTimeout(() => {
        searchNzPostAddresses(query);
      }, 300);
    });

    addressInput.addEventListener("keydown", (event) => {
      if (addressSuggestions.hidden) return;

      if (event.key === "ArrowDown") {
        event.preventDefault();
        setActiveAddress(activeAddressIndex + 1);
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        setActiveAddress(activeAddressIndex - 1);
      }

      if (
        event.key === "Enter" &&
        activeAddressIndex >= 0 &&
        currentAddressResults[activeAddressIndex]
      ) {
        event.preventDefault();
        chooseAddress(currentAddressResults[activeAddressIndex]);
      }

      if (event.key === "Escape") {
        closeAddressSuggestions();
      }
    });

    addressInput.addEventListener("blur", () => {
      setTimeout(closeAddressSuggestions, 150);
    });
  }

  if (!openButton || !modal || !closeButton || !doneButton || !form) return;

  document.body.appendChild(modal);

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = "";
  }

  function showMessage(message) {
    if (!errorBox) return;
    errorBox.hidden = false;
    errorBox.textContent = message;
  }

  function clearMessage() {
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = "";
  }

  openButton.addEventListener("click", () => {
    clearMessage();
    modal.hidden = false;
    document.body.style.overflow = "hidden";
  });

  closeButton.addEventListener("click", closeModal);

  if (cancelButton) {
    cancelButton.addEventListener("click", closeModal);
  }

  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      closeModal();
    }
  });

  doneButton.addEventListener("click", async () => {
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    clearMessage();

    const originalButtonText = doneButton.textContent;

    doneButton.disabled = true;
    doneButton.textContent = "Submitting...";

    try {
      const formData = new FormData(form);
      const lineItems = [];

      document
        .querySelectorAll("[data-quantity-variant-id]")
        .forEach((input) => {
          const quantity = Number(input.value);
          const variantId = input.getAttribute("data-quantity-variant-id");

          if (!variantId || !quantity || quantity <= 0) return;

          lineItems.push({
            variantId: `gid://shopify/ProductVariant/${variantId}`,
            quantity,
          });
        });

      if (lineItems.length === 0) {
        throw new Error(
          "We couldn't read the products in your cart. Please refresh the page and try again."
        );
      }

      const payload = {
        company: formData.get("company"),
        contactName: formData.get("contactName"),
        email: formData.get("email"),
        phone: formData.get("phone"),
        deliveryMethod: formData.get("deliveryMethod"),
        deliveryAddress: formData.get("deliveryAddress"),
        requestedDate: formData.get("requestedDate"),
        poNumber: formData.get("poNumber"),
        notes: formData.get("notes"),
        lineItems,
      };

      console.log("Submitting ACE order:", payload);

      const response = await fetch("/apps/ace-order-gateway", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const rawText = await response.text();

      console.log("ACE raw response status:", response.status);
      console.log("ACE raw response body:", rawText);

      let result = null;

      if (rawText) {
        try {
          result = JSON.parse(rawText);
        } catch (parseError) {
          console.warn("Response was not valid JSON:", parseError);
        }
      }

      if (!response.ok) {
        throw new Error(
          result?.message ||
          result?.error ||
          `Server returned HTTP ${response.status}`
        );
      }

      if (!result?.ok) {
        throw new Error(
          result?.message ||
          result?.error ||
          "The order gateway did not confirm success."
        );
      }
      // Draft order has been successfully created.
// Clear the customer's Shopify cart.
try {
  const clearCartResponse = await fetch(
    window.Shopify.routes.root + "cart/clear.js",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!clearCartResponse.ok) {
    console.warn(
      "Draft order created, but cart could not be cleared:",
      clearCartResponse.status
    );
  }
} catch (clearCartError) {
  console.warn(
    "Draft order created, but cart clearing failed:",
    clearCartError
  );
}

      form.innerHTML = `
        <div class="ace-order-success">
          <h2>Thank you</h2>
          <p>Your order request has been received.</p>
          <p>
            Our team will review your order, confirm freight where required,
            and email you a secure payment link.
          </p>
          ${
            result.draftOrder?.name
              ? `<p><strong>Reference: ${result.draftOrder.name}</strong></p>`
              : ""
          }
          <button
            type="button"
            id="ace-order-success-close"
            class="button"
          >
            Done
          </button>
        </div>
      `;

      const successCloseButton = document.getElementById(
        "ace-order-success-close"
      );

      if (successCloseButton) {
        successCloseButton.addEventListener("click", () => {
          window.location.href = "/";
        });
      }
    } catch (error) {
      console.error("ACE Order Gateway submission error:", error);

      showMessage(
        error instanceof Error
          ? error.message
          : "We couldn't submit your order. Please try again."
      );
    } finally {
      if (document.body.contains(doneButton)) {
        doneButton.disabled = false;
        doneButton.textContent = originalButtonText || "Done";
      }
    }
  });
});